<template>
  <div class="venue-order-actions">
    <div v-if="showSummary && count > 0" class="venue-order-actions__head">
      <div class="checkout-step__mobile-copy" aria-live="polite" aria-atomic="true">
        <small>Subtotal de tu pedido</small>
        <span class="checkout-step__mobile-total">{{ amount }}</span>
        <small>{{ count }} acceso{{ count === 1 ? '' : 's' }}<template v-if="sectionCount"> · {{ sectionCount }} {{ sectionCount === 1 ? 'sección' : 'secciones' }}</template></small>
      </div>
      <button v-if="showDetails && lines.length" class="venue-order-actions__link" type="button" :aria-expanded="expanded" @click="expanded = !expanded">{{ expanded ? 'Ocultar pedido' : 'Ver pedido' }}</button>
    </div>
    <div v-if="showDetails && expanded && count > 0 && lines.length" class="venue-order-actions__items checkout-step__selection-list">
      <div v-for="line in lines" :key="line.key" class="checkout-step__selection-item">
        <div><strong>{{ line.name }} × {{ line.quantity }}</strong><small>{{ line.section }}</small></div>
        <span>{{ line.amount }}</span>
      </div>
    </div>
    <p v-if="message" class="venue-order-actions__message" role="status">{{ message }}</p>
    <p v-else-if="helperText" class="venue-order-actions__helper">{{ helperText }}</p>
    <div class="venue-order-actions__buttons">
      <button class="btn btn-primary checkout-step__button checkout-step__button--summary liquid-page-button" type="button" :disabled="disabled" @click="$emit('continue')">
        <span class="liquid-page-button__glow" aria-hidden="true"></span>
        <span class="liquid-page-button__ring" aria-hidden="true"></span>
        <span class="liquid-page-button__inner">
          <span class="liquid-page-button__copy">{{ busy ? 'Actualizando...' : actionLabel }}</span>
          <span class="liquid-page-button__icon"><i class="fas fa-arrow-right" aria-hidden="true"></i></span>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VenueOrderActions',
  props: {
    amount: { type: String, required: true },
    count: { type: Number, default: 0 },
    sectionCount: { type: Number, default: 0 },
    lines: { type: Array, default: () => [] },
    disabled: Boolean,
    busy: Boolean,
    showSummary: { type: Boolean, default: true },
    showDetails: { type: Boolean, default: true },
    actionLabel: { type: String, default: 'Continuar' },
    helperText: { type: String, default: '' },
    message: { type: String, default: '' },
  },
  emits: ['continue'],
  data: () => ({ expanded: false }),
}
</script>

<style scoped>
.venue-order-actions { display: grid; gap: 12px; min-width: 0; }
.venue-order-actions__head { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.venue-order-actions__buttons { display: flex; align-items: center; gap: 12px; }
.venue-order-actions__buttons > .liquid-page-button { flex: 1; height: 56px !important; min-height: 56px !important; width: 100% !important; min-width: 0; margin: 0 !important; }
.venue-order-actions .liquid-page-button__inner { height: 52px !important; min-height: 52px !important; }
.venue-order-actions__link { color: #edf3ff; font: inherit; cursor: pointer; }
.venue-order-actions__link { background: none; border: 0; text-decoration: underline; text-underline-offset: 4px; min-height: 44px; }
.venue-order-actions__items { max-height: min(180px, 24dvh); overflow-y: auto; overscroll-behavior: contain; }
.venue-order-actions__items .checkout-step__selection-item { font-size: .85rem; }
.venue-order-actions__items span { white-space: nowrap; }
.venue-order-actions__message { margin: 0; color: #f3d9aa; font-size: .8rem; }
.venue-order-actions__helper { margin: 0; color: #cad4e4; font-size: .8125rem; line-height: 1.5; }
@media (max-width: 480px) {
  .venue-order-actions { gap: 8px; }
  .venue-order-actions .liquid-page-button__inner { gap: 6px; padding: 0 8px; }
  .venue-order-actions .liquid-page-button__copy { font-size: clamp(.78rem, 3.4vw, .9rem); }
  .venue-order-actions .liquid-page-button__icon { flex: 0 0 24px; width: 24px; height: 24px; }
  .venue-order-actions__buttons { gap: 8px; }
  .venue-order-actions__link { font-size: .8rem; }
  .venue-order-actions .checkout-step__mobile-total { font-size: 1.6rem; }
}
</style>
